import { useCallback, useMemo } from "react";
import {
  getColor,
  getTextColor,
  getBlockquoteTextColor,
  getCodeSnippetTextColor,
} from "../../utils";

export function useEditorColors(bgColorKey: string, theme?: Record<string, string>) {
  const getBackgroundColor = useCallback(
    (bgColor: string): string => {
      if (!bgColor || bgColor === "clear") return getColor("white");
      if (theme?.[bgColor]) {
        return theme[bgColor];
      }
      if (bgColor.includes("Color")) {
        return getColor(bgColor.replace("Color", "")) || "";
      }
      if (bgColor === "default") return getColor("white");
      return getColor(bgColor);
    },
    [theme]
  );

  return useMemo(() => {
    const bg = getBackgroundColor(bgColorKey);
    return {
      backgroundColor: bg,
      color: getTextColor(bg),
      blockquoteColor: getBlockquoteTextColor(bg),
      codeSnippetColor: getCodeSnippetTextColor(bg),
    };
  }, [bgColorKey, getBackgroundColor]);
}
